<template>
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
  >
    <path d="M10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21C13.0394 21 15.3683 20.0985 17.1841 18.5981L24.293 25.7071C24.6836 26.0976 25.3167 26.0976 25.7073 25.7071C26.0978 25.3166 26.0978 24.6834 25.7073 24.2929L18.5983 17.1839C20.0986 15.3682 21 13.0393 21 10.5C21 4.70101 16.299 0 10.5 0ZM2 10.5C2 5.80558 5.80558 2 10.5 2C15.1944 2 19 5.80558 19 10.5C19 15.1944 15.1944 19 10.5 19C5.80558 19 2 15.1944 2 10.5Z" />
  </svg>
</template>
